import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MyThunkDispatch, RootState } from 'store';

import { fetchCountryList, fetchRestCountryList } from 'actions/i18n';
import Invite from 'screens/components/Invite';
import { resendTwoFactor } from 'services/otpService';
import { linkRappiUser, LinkRappiUserRequest } from 'services/registrationService';

const InviteContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();

  const { restCountries } = useSelector((state: RootState) => state.i18n);

  const fetchCountryCodes = useCallback(() => dispatch(fetchRestCountryList()), [dispatch]);
  const fetchAvailableCountries = useCallback(() => dispatch(fetchCountryList()), [dispatch]);

  const linkUser = (data: LinkRappiUserRequest) => linkRappiUser(data);
  const resendTwoFactorAuth = (key: string) => resendTwoFactor(key);

  return (
    <Invite
      fetchAvailableCountries={fetchAvailableCountries}
      fetchCountryCodes={fetchCountryCodes}
      linkRappiUser={linkUser}
      restCountries={restCountries}
      resendTwoFactor={resendTwoFactorAuth}
    />
  );
};

export default InviteContainer;
